import { render, staticRenderFns } from "./InventoryAdvancePaymentCommentListItem.vue?vue&type=template&id=40487ed8&"
import script from "./InventoryAdvancePaymentCommentListItem.vue?vue&type=script&lang=ts&"
export * from "./InventoryAdvancePaymentCommentListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports